import Vue from 'vue'
import App from './App'
import './registerServiceWorker'
import vuetify from '@/plugin/vuetify-plugin'
import routerProvider from './router'
import store from './store'

import { initializeApp } from 'firebase/app'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { getPerformance } from 'firebase/performance'
import { setAuthenticationApp, onLogout, observeAccountIdTokenRefresh } from './util/accountUtil'
import { setStoresApp, connectStoreEmulators } from './util/firestoreUtil'
import { setAnalyticsApp } from './util/analyticsUtil'
import { getLCP, getFID, getCLS } from 'web-vitals'

// Local plugins
import AppEnvironmentPlugin from '@/plugin/app-environment-plugin'
import AppLoggerPlugin from '@/plugin/app-logger-plugin'
import AccountPlugin from '@/plugin/account-plugin'
import AppErrorPlugin from './plugin/app-error-plugin'
import AppLayoutPlugin from './plugin/app-layout-plugin'
import ReloadSitePlugin from './plugin/reload-site-plugin'
import EventBusPlugin from './plugin/event-bus-plugin'

import firebaseConfig from '@/configs/firebase-config'

Vue.use(AppEnvironmentPlugin)
Vue.use(AppLoggerPlugin)
Vue.use(AccountPlugin)
Vue.use(AppErrorPlugin)
Vue.use(AppLayoutPlugin)
Vue.use(ReloadSitePlugin)
Vue.use(EventBusPlugin)

Vue.config.productionTip = false

const router = routerProvider.getRouter()

const firebaseApp = initializeApp(firebaseConfig)
setAuthenticationApp(firebaseApp)
setStoresApp(firebaseApp)
setAnalyticsApp(firebaseApp)
// Use reference to perform additional monitoring https://firebase.google.com/codelabs/firebase-perf-mon-web#5
// const perf = getPerformance(firebaseApp)
getPerformance(firebaseApp)
if (process.env.VUE_APP_ENVIRONMENT === 'development') {
  const isLocalhost = window.location.hostname === 'localhost'
  const urlString = window.location.origin
  const isLan = /^http:\/\/10.0.0./.test(urlString)
  if (isLocalhost || isLan) {
    const url = new URL(urlString)
    const host = url.hostname
    connectStoreEmulators(host)
  }
}

let authChangeSubscription = null
let app = null

const firebaseAuth = getAuth()

function setupVueApp () {
  if (authChangeSubscription != null) {
    Vue.logger.log('App setup has already commenced')
    return
  }

  authChangeSubscription = onAuthStateChanged(firebaseAuth, () => {
    // Create app if necessary
    if (app == null) {
      /* eslint-disable no-new */
      app = new Vue({
        vuetify,
        router,
        store,
        render: h => h(App)
      }).$mount('#app')
    }
    authChangeSubscription()

    // Resubscribe and broadcasts account changes through the store
    onAuthStateChanged(firebaseAuth, user => {
      store.dispatch('updateAccount', user)
      if (user) {
        observeAccountIdTokenRefresh(user)
        user.getIdToken()
          .then(idToken => Vue.logger.log(user.uid, idToken))
          .catch(Vue.logger.error)
      } else {
        onLogout()
      }
    })
  })
}

setupVueApp()

getCLS(console.log)
getFID(console.log)
getLCP(console.log)
